export default __webpack_public_path__ + "static/media/infra-3.397cf482.webp";